import { useModal } from 'commons/hooks';
import { logMoreDiscountsModalOpened } from 'domains/Marketing/components/MoreDiscounts';

export function useMoreDiscountsModal(listPage: string) {
  const [isOpen, open, close] = useModal();

  const handleOpen = () => {
    logMoreDiscountsModalOpened(listPage);
    open();
  };

  return {
    moreDiscountsIsOpen: isOpen,
    openMoreDiscounts: handleOpen,
    closeMoreDiscounts: close,
  };
}
